import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  additionalInfo: {
    color: palette.shades[700]
  },
  successBlockWrapper: {
    marginTop: '48px',
    textAlign: 'center'
  },
  controller: {
    color: palette.primary.dark,
    cursor: 'pointer'
  }
});
export default useStyles;